import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { KendoGridHelper } from 'src/app-core/helper/kendo-grid-helper';

@Injectable({
    providedIn: 'root'
})

export class CommonMethod {
    kendogridHelper = new KendoGridHelper();
    oidcCNFFranchaiseIdLocalStorage = 'oidcCNFFranchaiseId';
    oidcCNFFranchaiseGuidLocalStorage = 'oidcCNFFranchaiseGuid';

    constructor() {
    }

    setAddressFromAccount = new Subject<any>();

    private setIsTenantId = new BehaviorSubject<any>(0);
    getTenantId = this.setIsTenantId.asObservable();

    sendTenantId(data: any) {
        this.setIsTenantId.next(data);
    }

    private setIsInternationalZipcode = new BehaviorSubject<boolean>(false);
    getIsInternationalZipcode = this.setIsInternationalZipcode.asObservable();

    sendIsInternationalZipcode(data: boolean) {
        this.setIsInternationalZipcode.next(data);
    }

    private setIsAccountId = new BehaviorSubject<any>('');
    getIsAccountId = this.setIsAccountId.asObservable();

    sendIsAccountId(data: any) {
        this.setIsAccountId.next(data);
    }

    private setTabName = new BehaviorSubject<any>('');
    getTabName = this.setTabName.asObservable();

    sendTabName(data: any) {
        this.setTabName.next(data);
    }

    private setValue = new BehaviorSubject<any>(0);
    getValue = this.setValue.asObservable();

    sendValue(data: any) {
        this.setValue.next(data);
    }

    private setTenantList = new BehaviorSubject<any>({});
    getTenantList = this.setTenantList.asObservable();

    sendTenantList(data: any) {
        this.setTenantList.next(data);
    }

    private setOrderId = new BehaviorSubject<any>(0);
    getOrderId = this.setOrderId.asObservable();

    sendOrderId(data: any) {
        this.setOrderId.next(data);
    }

    private setAutoPopulateAccountId = new BehaviorSubject<any>(0);
    getAutoPopulateAccountId = this.setAutoPopulateAccountId.asObservable();

    sendAutoPopulateAccountId(data: any) {
        this.setAutoPopulateAccountId.next(data);
    }

    private setPayerData = new BehaviorSubject<any>('');
    getPayerData = this.setPayerData.asObservable();

    sendPayerData(data: any) {
        this.setPayerData.next(data);
    }

    private setIsTaxable = new BehaviorSubject<boolean>(false);
    getIsTaxable = this.setIsTaxable.asObservable();

    sendIsTaxable(data: boolean) {
        this.setIsTaxable.next(data);
    }

    private setIsTaxColumnVisible = new BehaviorSubject<boolean>(false);
    getIsTaxColumnVisible = this.setIsTaxColumnVisible.asObservable();

    sendIsTaxColumnVisible(data: boolean) {
        this.setIsTaxColumnVisible.next(data);
    }

    private setIsTaxValue = new BehaviorSubject<any>(0);
    getIsTaxValue = this.setIsTaxValue.asObservable();

    sendIsTaxValue(data: boolean) {
        this.setIsTaxValue.next(data);
    }

    private setIsTaxTotal = new BehaviorSubject<any>(0);
    getIsTaxTotal = this.setIsTaxTotal.asObservable();

    sendIsTaxTotal(data: boolean) {
        this.setIsTaxTotal.next(data);
    }

    // Base64 Encode
    base64Encode(data: any) {
        return window.btoa(JSON.stringify(data));
    }

    // Base64 Decode
    base64Decode(data: any) {
        return JSON.parse(window.atob(data));
    }

    // Set FranchiseId
    setFranchiseId(data: any) {
        localStorage.setItem(this.oidcCNFFranchaiseIdLocalStorage, data);
    }

    // Set FranchiseGuid
    setFranchiseGuid(data: any) {
        localStorage.setItem(this.oidcCNFFranchaiseGuidLocalStorage, data);
    }

    getFranchiseId() {
        if (localStorage.getItem(this.oidcCNFFranchaiseIdLocalStorage)) {
            return this.base64Decode(localStorage.getItem(this.oidcCNFFranchaiseIdLocalStorage));
        }
        return false;
    }

    getFreightClass(density: number): string {
        if (density >= 50) return '50';
        else if (density >= 35) return '55';
        else if (density >= 30) return '60';
        else if (density >= 22.5) return '65';
        else if (density >= 15) return '70';
        else if (density >= 13.5) return '77.5';
        else if (density >= 12) return '85';
        else if (density >= 10.5) return '92.5';
        else if (density >= 9) return '100';
        else if (density >= 8) return '110';
        else if (density >= 7) return '125';
        else if (density >= 6) return '150';
        else if (density >= 5) return '175';
        else if (density >= 4) return '200';
        else if (density >= 3) return '250';
        else if (density >= 2) return '300';
        else if (density >= 1) return '400';
        else return '500';
    }

    calculateVolume(dataItem: any): number {
        return (dataItem.length * dataItem.width * dataItem.height * dataItem.quantity) / 1728;
    }

    calculateTotalWeight(dataItem: any): number {
        const volume = this.calculateVolume(dataItem);
        return (dataItem.weight) / volume;
    }

    expandRows(grid: any): void {
        for (let i = this.kendogridHelper.skipCount; i < this.kendogridHelper.skipCount * this.kendogridHelper.defaultRecordsCountPerPage + this.kendogridHelper.defaultRecordsCountPerPage; i++) {
            grid.expandRow(i);
        }
    }

    convertDecimalToNextWholeNumber(value: number): number {
        const decimalPart = +(value.toString().split('.')[1] || 0);
    
        if (value > 0 && decimalPart > 0) {
          return Math.round(value + 0.5);
        }
    
        return value;
      }

}